export default "__VITE_ASSET__C30zh7pO__"